import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { smartDocExternalParamType_API, smartDocParamType_Dynamic } from '@app/advisor-content-shared';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { ICONS } from '@app/styles';
import { DropDown_SmartDocParamSubType } from '../DropDown_SmartDocParamSubType.js';
import { smartDocExternalParam_ParamKeys, smartDocExternalParam_ParamKeys_LabelMap } from '@app/advisor-content-shared/_enum/smart-doc-parameter/external/param-key';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_SmartDocParam_External extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        state.params = nextProps.params;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.renderSubType(), this.render_ParamKey(), this.renderDeleteButton()] });
    }
    renderSubType = () => {
        const param = this.state.editable;
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "And sub type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: param.item.subType ?? 'N/A' }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_SmartDocParamSubType, { editable: param, allowedParamSubTypes: this.props.allowedParamSubTypes }) }
                    ] })] });
    };
    renderDeleteButton = () => {
        if (!this.state.editMode)
            return;
        const param = this.state.editable;
        const canDelete = !this.state.params.some(_param => _param?.type === smartDocParamType_Dynamic && _param.externalKey === param.item.key);
        const className = _className('editor__smart-doc-param__delete', !canDelete && 'disabled');
        return _jsx(ICONS.bin.component, { className: className, onClick: () => {
                if (!canDelete)
                    return;
                return param.delete();
            } });
    };
    render_ParamKey = () => {
        const param = this.state.editable;
        if (param.item.subType !== smartDocExternalParamType_API)
            return;
        const currentParamKey = smartDocExternalParam_ParamKeys_LabelMap[param.item.paramKey] ?? 'N/A';
        const adapter = SimpleListAdapter([...smartDocExternalParam_ParamKeys], key => _jsx(_Fragment, { children: smartDocExternalParam_ParamKeys_LabelMap[key.item] }));
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "And Param Key" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: currentParamKey }) }) },
                        {
                            key: viewMode_Edit, renderer: () => _jsx(TS_DropDown, { adapter: adapter, selected: param.item.paramKey, onSelected: key => param.updateObj({ paramKey: key }) })
                        }
                    ] })] });
    };
}
//# sourceMappingURL=Editor_SmartDocParam_External.js.map